// Synthesized "pop" notification — Discord-style two-tone bop using Web Audio
// API. Avoids shipping an audio file and respects the user's autoplay policy:
// the first AudioContext is created lazily on the first call (which usually
// happens after a user gesture inside the app like clicking Send/Login).
let _ctx = null;
let _enabled = true;

function getCtx() {
  if (typeof window === "undefined") return null;
  if (!_ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    try {
      _ctx = new AC();
    } catch {
      return null;
    }
  }
  if (_ctx.state === "suspended") {
    _ctx.resume().catch(() => {});
  }
  return _ctx;
}

function playPop(ctx, start, freq, peak = 0.22) {
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = "sine";
  osc.frequency.setValueAtTime(freq, start);
  osc.frequency.exponentialRampToValueAtTime(freq * 0.5, start + 0.13);
  gain.gain.setValueAtTime(0.0001, start);
  gain.gain.exponentialRampToValueAtTime(peak, start + 0.012);
  gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.2);
  osc.connect(gain).connect(ctx.destination);
  osc.start(start);
  osc.stop(start + 0.22);
}

export function playNewMessageSound() {
  if (!_enabled) return;
  try {
    const ctx = getCtx();
    if (!ctx) return;
    const now = ctx.currentTime + 0.005;
    playPop(ctx, now, 880);
    playPop(ctx, now + 0.075, 660);
  } catch {
    /* swallow — sound is best-effort */
  }
}

// Optional: let consumers mute the sound globally (e.g. user preference).
export function setNotificationSoundEnabled(value) {
  _enabled = Boolean(value);
}
